module.exports = __webpack_public_path__ + "static/media/feedbck-2.f680ebd0.png";